import MuiTabPanel from "@mui/lab/TabPanel";
import { styled } from "@mui/material/styles";

/**
 * The tab body inside a side panel's `contentBox`.
 *
 * `contentBox` is a bare flex column and no longer scrolls, so this panel is the scroll container
 * for an ordinary tab. A tab whose main content is a table passes `fill` instead: the panel then
 * stops scrolling and passes its height down, letting the table fill the panel, scroll internally
 * and keep its pagination footer pinned — the same contract the full-page tables follow.
 *
 * Padding is deliberately left at the MUI default: `PaneElement.Container` adds its own on top,
 * and together they are the spacing every tab has always had.
 *
 * MUI hides an inactive panel with the `hidden` attribute, which relies on the UA stylesheet's
 * `display: none`. Any `display` declared here outranks that and would reveal every panel at
 * once, hence the explicit guard — keep it if you touch the `fill` branch.
 */
export const PaneTabPanel = styled(MuiTabPanel, {
    shouldForwardProp: (prop) => prop !== "fill",
})<{ fill?: boolean }>(({ fill }) => ({
    flex: 1,
    minHeight: 0,
    ...(fill ? { display: "flex", flexDirection: "column", overflow: "hidden" } : { overflow: "auto" }),
    "&[hidden]": {
        display: "none",
    },
}));
